// Module
var code = "<template>\n\t<require from=\"./new-report-wizard\"></require>\n\t<new-report-wizard></new-report-wizard>\n</template>\n";
// Exports
export default code;